const initialState = {
    show: false,
    title: "",
    className: "",
    content: "",
    isConfirmation: false,
    callBackFunction: null
};

export const notificationBoxReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SHOW_NOTIFICATION_BOX':
            return {
                show: action.payload.show,
                title: action.payload.title,
                className: action.payload.className,
                content: action.payload.content,
                isConfirmation: action.payload.isConfirmation,
                callBackFunction: action.payload.callBackFunction
            };
        case 'RESET_NOTIFICATION_BOX':
            return initialState;
        default:
            return state;
    }
};